import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import { TimeReportItem } from './types';
import { TimeSheetGroupType } from '../schedule/types';

interface State {
    data: Array<TimeReportItem>
    /* Kept in the store so the chosen view survives a trip to the favourites page, like the filters do. */
    groupBy: TimeSheetGroupType
}

const initialState: State = {
    data: [],
    groupBy: TimeSheetGroupType.EMPLOYEEVIEW
}

const timeReportSlice = createSlice({
    name: 'timereport',
    initialState,
    reducers: {
        clearData: (state) => {
            state.data = []
        },
        setData: (state, action: PayloadAction<Array<TimeReportItem>>) => {
            state.data = action.payload
        },
        setGroupBy: (state, action: PayloadAction<TimeSheetGroupType>) => {
            state.groupBy = action.payload
        }
    }
})

export const { clearData, setData, setGroupBy } = timeReportSlice.actions;

export default timeReportSlice.reducer;
